module.exports = __webpack_public_path__ + "static/media/pinterest.8799b140.svg";